import { createContext, useContext } from 'react';
import type { Domain } from './types';

// Shared resource views use explicit account routes inside the user workspace.
// The server independently authorizes every request; this only chooses the URL.
export const ResourceApiContext = createContext('/api/admin');
export const useResourceApi = () => useContext(ResourceApiContext);
export const DomainCatalogContext = createContext<(domains: Domain[]) => void>(() => {});
